/**
 * Feature flag key constants used across the frontend.
 *
 * These correspond to flags configured in Growthbook. Use with the
 * `useFeatureIsOn` hook from `@growthbook/growthbook-react`.
 */

// Broker Portal
export const CENSUS_ELIMINATE_REDUNDANCY = "census-eliminate-redundancy";
export const JIRA_SERVICE_DESK_WIDGET = "jira-service-desk-widget";
export const CONSULTANT_VIEW = "consultant-view";
export const CONSULTANT_STEWARDSHIP_REPORTING =
  "consultant-stewardship-reporting";
export const CONSULTANT_STEWARDSHIP_PENDING_PREMIUM_FALLBACK =
  "consultant-stewardship-pending-premium-fallback";
export const REMOVE_IGO = "remove-IGO";
export const STEWARDSHIP_EXPORT_TURNAROUND_DAYS =
  "stewardship-export-turnaround-days";
export const STEWARDSHIP_DISCOVERABLE_SORT = "stewardship-discoverable-sort";
export const RFP_COPY = "rfp-copy";
export const RECORD_INSPECTOR = "record-inspector";
export const CENSUS_VALIDATION_PAGE = "census-validation-page";
// A JSON value, not a boolean: an object keyed by broker id. Read it with
// `useCensusUploadCheckEnabled` from `@platform/census-validation`.
export const CENSUS_UPLOAD_CHECK = "census-upload-check";

// BTX / Build Tab Extreme
export const BTX_ANALYST_NOTEPAD = "btx-analyst-notepad";
export const BUILD_TAB_EXTREME_NEEDS_REVIEW_PANEL =
  "build-tab-extreme-needs-review-panel";
export const NEW_DELETE_PLAN_VALIDATION = "new-delete-plan-validation";
export const BTX_CURRENT_CARRIER_POLICY_DROPDOWN =
  "btx-current-carrier-policy-dropdown";
export const BTX_COMMISSION_PREPOPULATION = "btx.commission-prepopulation";
export const BTX_DEPENDENT_RATE_BASIS = "btx-dependent-rate-basis";
export const BTX_CH_BENEFITS_FIELD = "btx-ch-benefits-field";

// AI Docs
export const AI_DOCS_UI_BULK = "ai-docs-ui-bulk";
export const PROPELX = "PropElX-Core-July2026";
export const RFP_ASSISTANT_UI = "rfp-assistant-ui";

// Rumi
export const RUMI_LAUNCHPAD = "rumi-launchpad";

// Employee Navigator
export const EN_CENSUS_FEATURE_ENABLED = "employee-navigator-active";
export const EN_CENSUS_FOR_PROSPECTS = "employee-navigator-census-prospects";
export const EN_PUSH_SOLD_PLAN_DATA_FEATURE_ENABLED =
  "employee-navigator-push-sold-plan-data";

// BBE
export const BBE_MONTHLY_PROGRESS = "bbe-monthly-progress";
export const BBE_SCENARIO_MODELING = "bbe-scenario-modeling";

// PPX
export const PPX_ADD_PLAN_MODAL = "ppx-add-plan-modal";
export const PPX_QUOTE_HISTORY = "ppx-quote-history";
export const PPX_FINANCIALS_PREMIUM_OVERRIDES =
  "PPX_Financials_premium_overrides";

// Centro Portal (BFF)
// Same flag the ai-dox extraction pipeline reads through
// `flags.AiDoxExtendedCoverages`, so the coverages centro-portal reports as
// supported and the ones the pipeline actually extracts stay in agreement.
export const AI_DOX_EXTENDED_COVERAGES = "ai-dox-extended-coverages";

// Design System
export const KAIZEN_THEME = "kaizen-theme";

// Carrieres Rep Directory
export const CARRIERS_REP_DIRECTORY = "carriers-rep-directory";
